"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shield_home = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var shield_home = function shield_home(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'shield-home-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M7 13V9.01923L10 7L13 9.01923V13H7Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.56407 1.3897C9.82484 1.20343 10.1752 1.20343 10.4359 1.3897L11.3564 2.04719C12.9535 3.18795 14.8013 3.92828 16.7442 4.20584L17.1061 4.25754C17.4756 4.31032 17.75 4.62676 17.75 5V10.7805C17.75 13.0429 16.7614 15.1923 15.0436 16.6647C12.1413 19.1524 7.85866 19.1524 4.95637 16.6647C3.23861 15.1923 2.25 13.0429 2.25 10.7805V5C2.25 4.62676 2.52445 4.31032 2.89393 4.25754L3.25583 4.20584C5.19874 3.92828 7.04652 3.18795 8.64358 2.04719L9.56407 1.3897ZM10 2.92168L9.51544 3.26779C7.80026 4.49292 5.82746 5.30658 3.75 5.64748V10.7805C3.75 12.605 4.54727 14.3384 5.93255 15.5258C8.27312 17.532 11.7269 17.532 14.0674 15.5258C15.4527 14.3384 16.25 12.605 16.25 10.7805V5.64748C14.1725 5.30658 12.1997 4.49292 10.4846 3.26779L10 2.92168Z',
    fill: '#4B5563'
  }));
};

exports.shield_home = shield_home;